/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AdmissionTypeApi } from '../api/admissiontype.api';
import { switchMap, map } from 'rxjs/operators';
import { AdmissionType,AdmissionTypeData } from '../../../interfaces/masters/admissiontype';

@Injectable()
export class AdmissionTypeService extends AdmissionTypeData {

  constructor(private api:AdmissionTypeApi) {
    super();
  }


  list(url: string): Observable<AdmissionType[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<AdmissionType>{
      return this.api.getById(url);
  }

  create(url: string, data:AdmissionType): Observable<AdmissionType> {
    return this.api.add(url,data);
  }

  update(url: string, data:AdmissionType): Observable<AdmissionType> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
